import { render } from "./inbox.vue?vue&type=template&id=2d738e8c&ts=true"
import script from "./inbox.vue?vue&type=script&lang=ts"
export * from "./inbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__